<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <EntityTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CTextarea 
                            v-model="entity.description"
                            label="Краткое описание"
                            placeholder="Укажите краткое описание (не более 255 символов)"
                        />
                        <CRow v-if="entity.picture">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol
                                sm="9"
                                class="col-form-label"
                            ><CImg
                                :src="pictureUrl"
                                class="m2"
                                width="200"
                            /></CCol>
                        </CRow>
                        <CInputFile
                            ref="picture"
                            label="Изображение сервиса (мобильное приложение)"
                            horizontal
                            @change="selectPicture"
                        />

                        <CRow v-if="entity.square_picture">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol
                                sm="9"
                                class="col-form-label"
                            ><CImg
                                :src="squarePictureUrl"
                                class="m2"
                                width="100"
                            /></CCol>
                        </CRow>
                        <CInputFile
                            ref="picture"
                            label="Изображение для поиска"
                            horizontal
                            @change="selectSquarePicture"
                        />
                        <br><br>
                        <CRow v-if="entity.desktop_picture">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol
                                sm="9"
                                class="col-form-label"
                            ><CImg
                                :src="desktopPictureUrl"
                                class="m2"
                                width="100"
                            /></CCol>
                        </CRow>
                        <CInputFile
                            ref="picture"
                            label="Изображение для десктопа (внутри сервиса)"
                            horizontal
                            @change="selectDesktopPicture"
                        />
                        <CRow v-if="entity.desktop_picture_list">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol
                                sm="9"
                                class="col-form-label"
                            ><CImg
                                :src="desktopPictureUrlInList"
                                class="m2"
                                width="100"
                            /></CCol>
                        </CRow>
                        <CInputFile
                            ref="picture"
                            label="Изображение для десктопа (список)"
                            horizontal
                            @change="selectDesktopPictureInList"
                        />
                        <CRow v-if="entity.popular_picture">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol
                                sm="9"
                                class="col-form-label"
                            ><CImg
                                :src="popularPictureUrl"
                                class="m2"
                                width="100"
                            /></CCol>
                        </CRow>
                        <CInputFile
                            ref="picture"
                            label="Изображение для популярного"
                            horizontal
                            @change="selectPopularPicture"
                        />

                        <CRow v-if="entity.description_picture">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol
                                sm="9"
                                class="col-form-label"
                            ><CImg
                                :src="descriptionPictureUrl"
                                class="m2"
                                width="100"
                            /></CCol>
                        </CRow>
                        <CInputFile
                            ref="picture"
                            label="Изображение для описания"
                            horizontal
                            @change="selectDescriptionPicture"
                        />

                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Мелкая плитка товаров
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.small_cards"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Страница категорий
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.categories_page"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Показывать изображение для описания
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.show_description_picture"
                                />
                            </CCol>
                        </CRow>

                        <CInput v-model="entity.phone" label="Телефон" />
                        <CInput v-model="entity.open_at" label="Открывается в" />
                        <CInput v-model="entity.close_at" label="Закрывается в" /> 
                        <CInput
                            v-model="entity.min_price"
                            label="Минимальный заказ"
                        />

                        <CInput
                            v-model="entity.min_price_pickup"
                            label="Минимальная сумма для самовывоза"
                        />

                        <CInput
                            v-model.number="entity.weight_limit"
                            label="Ограничение по весу (грамм)" />
                        <CInput
                            v-if="entity.weight_limit && entity.weight_limit > 0"
                            v-model="entity.weight_limit_description"
                            label="Сообщение о превышении веса" />

                        <CRow>
                            <CCol>
                                <CInput
                                    v-model="entity.delay_time_hour"
                                    label="Время, необходимое на выполнение заказа (часы)"
                                    placeholder="часы"
                                />
                            </CCol>
                            <CCol>
                                <CInput
                                    v-model="entity.delay_time"
                                    label="Время, необходимое на выполнение заказа (минуты)"
                                    placeholder="минуты"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol>
                                <CInput
                                    v-model="entity.delivery_time_hour"
                                    label="Время доставки (часы)"
                                    placeholder="часы"
                                />
                            </CCol>
                            <CCol>
                                <CInput
                                    v-model="entity.delivery_time"
                                    label="Время доставки (минуты)"
                                    placeholder="минуты"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol>
                                <CInput
                                    v-model="entity.max_delivery_time_hour"
                                    label="Максимальное время доставки (часы)"
                                    placeholder="часы"
                                />
                            </CCol>
                            <CCol>
                                <CInput
                                    v-model="entity.max_delivery_time"
                                    label="Максимальное время доставки (минуты)"
                                    placeholder="минуты"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Калории за 100 г
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.calories_100g"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Отмена</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import EntityTabLinks from '@/components/entities/EntityTabLinks';
    import { xssRegEx } from '@/utils/rules';

    export default {
        name: 'EntityEdit',

        components: {
            EntityTabLinks,
        },

        data() {
            return {
                schedule: undefined,
                entity: {
                    id: 0,
                    code: '',
                    title: '',
                    short_name: '',
                    legal_entity: '',
                    alias: '',
                    description: '',
                    picture: '',
                    square_picture: '',
                    desktop_picture: '',
                    desktop_picture_list: '',
                    popular_picture: '',
                    small_cards: false,
                    categories_page: false,
                    show_description_picture: false,
                    extended_schedule: false,
                    tower: 0,
                    open_at: '',
                    close_at: '',
                    min_price: 0,
                    min_price_pickup: 0,
                    weight_limit: 0,
                    weight_limit_description: '',
                    phone: '',
                    delay_time: 0,
                    delay_time_hour: 0,
                    delivery_time: 0,
                    delivery_time_hour: 0,
                    max_delivery_time_hour: 0,
                    max_delivery_time: 0,
                    enabled: true,
                    position: 0,
                    calories_100g: false,
                    is_advertisement: false,
                },
                towers: [],
                selectedPicture: null,
                selectedSquarePicture: null,
                selectedDesktopPicture: null,
                selectedDesktopPictureInList: null,
                selectedPopularPicture: null,
                selectedDescriptionPicture: null,
            };
        },

        computed: {
            pictureUrl() {
                if (this.entity.picture) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.entity.picture
                    );
                } else {
                    return '';
                }
            },
            squarePictureUrl() {
                if (this.entity.square_picture) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.entity.square_picture
                    );
                } else {
                    return '';
                }
            },
            desktopPictureUrl() {
                if (this.entity.desktop_picture) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.entity.desktop_picture
                    );
                } else {
                    return '';
                }
            },
            desktopPictureUrlInList () {
                if (this.entity.desktop_picture_list) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.entity.desktop_picture_list
                    );
                } else {
                    return '';
                }
            },
            popularPictureUrl() {
                if (this.entity.popular_picture) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.entity.popular_picture
                    );
                } else {
                    return '';
                }
            },
            descriptionPictureUrl() {
                if (this.entity.description_picture) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.entity.description_picture
                    );
                } else {
                    return '';
                }
            },
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            },
        },

        mounted() {
            const id = this.$route.params.id;
            Vue.axios
                .get('/entities/get/' + id)
                .then(resp => {
                    this.entity = resp.data;
                    if(resp.data.schedule.length != 0){
                        this.schedule = resp.data.schedule;
                    }
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });

            if (!this.towers.length) {
                const towers = [{ value: null, label: 'Башня...' }];
                Vue.axios
                    .get('/address')
                    .then(({ data }) => {
                        data.forEach(tower => {
                            towers.push({ value: tower.id, label: tower.name });
                        });
                    });
                this.towers = towers;
            }
        },

        methods: {
            setSchedule(schedule){
                this.schedule = schedule;
            },

            selectPicture(FileList) {
                this.selectedPicture = FileList[0];
            },

            selectSquarePicture(FileList) {
                this.selectedSquarePicture = FileList[0];
            },

            selectDesktopPicture(FileList) {
                this.selectedDesktopPicture = FileList[0];
            },

            selectDesktopPictureInList(FileList) {
                this.selectedDesktopPictureInList = FileList[0];
            },

            selectPopularPicture(FileList) {
                this.selectedPopularPicture = FileList[0];
            },

            selectDescriptionPicture(FileList) {
                this.selectedDescriptionPicture = FileList[0];
            },

            async save() {
                if (!this.entity.title) {
                    this.$root.$emit('showError', 'Укажите название сервиса.');
                    return;
                }
                if (!this.entity.description) {
                    this.$root.$emit('showError', 'Укажите краткое описание сервиса.');
                    return;
                }
                if (xssRegEx.test(this.entity.description)) {
                    this.$root.$emit('showError', 'Описание содержит недопустимые символы.')
                    return
                }
                if (!this.entity.phone) {
                    this.$root.$emit('showError', 'Укажите номер телефона сервиса.');
                    return;
                }

                this.entity.schedule = this.schedule;

                try {
                    let formData = new FormData();

                    if (this.selectedSquarePicture) {
                        formData.append('file', this.selectedSquarePicture);
                        const squarePictureName = await Vue.axios.post('/files/upload', formData);
                        this.entity.square_picture = squarePictureName.data.filename;
                    }

                    if (this.selectedPicture) {
                        formData = new FormData();
                        formData.append('file', this.selectedPicture);
                        const uploadPicture = await Vue.axios.post('/files/upload', formData);
                        this.entity.picture = uploadPicture.data.filename;
                    }

                    if (this.selectedDesktopPicture) {
                        formData = new FormData();
                        formData.append('file', this.selectedDesktopPicture);
                        const uploadPicture = await Vue.axios.post('/files/upload', formData);
                        this.entity.desktop_picture = uploadPicture.data.filename;
                    }

                    if (this.selectedDesktopPictureInList) {
                        formData = new FormData();
                        formData.append('file', this.selectedDesktopPictureInList);
                        const uploadPicture = await Vue.axios.post('/files/upload', formData);
                        this.entity.desktop_picture_list = uploadPicture.data.filename;
                    }

                    if (this.selectedPopularPicture) {
                        formData = new FormData();
                        formData.append('file', this.selectedPopularPicture);
                        const uploadPicture = await Vue.axios.post('/files/upload', formData);
                        this.entity.popular_picture = uploadPicture.data.filename;
                    }

                    if (this.selectedDescriptionPicture) {
                        formData = new FormData();
                        formData.append('file', this.selectedDescriptionPicture);
                        const uploadPicture = await Vue.axios.post('/files/upload', formData);
                        this.entity.description_picture = uploadPicture.data.filename;
                    }

                    this.entity.min_price = this.entity.min_price ? +this.entity.min_price : 0;
                    this.entity.min_price_pickup = this.entity.min_price_pickup ? +this.entity.min_price_pickup : 0;
                    await Vue.axios.post(`/entities/update/${this.$route.params.id}`,this.entity);

                    this.goBack();
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка сохранения.');
                }
            },

            goBack() {
                this.$router.push({
                    path: `/entities/${this.$route.params.code}/${this.$route.params.id}`,
                });
            },
        },
    };
</script>

